import { render, staticRenderFns } from "./AcademicCalendar.vue?vue&type=template&id=04d92918&"
import script from "./AcademicCalendar.vue?vue&type=script&lang=ts&"
export * from "./AcademicCalendar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports